const t = {
  Summary: "SUMMARY",
  Detailed: "DETAILED",
  Exhaustive: "EXHAUSTIVE"
};
export {
  t
};
//# sourceMappingURL=Projection-c26049e7.mjs.map
